import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./style.module.css";
// Import all screenshots
import RefundStep1 from "../../images/processes/refund1.webp";
import RefundStep2 from "../../images/processes/refund2.webp";
import RefundStep3 from "../../images/processes/refund3.webp";
import RefundStep4 from "../../images/processes/refund4.webp";
import RefundStep5 from "../../images/processes/refund5.webp";
import RefundStep6 from "../../images/processes/refund6.webp";

const Refund = () => {
  const { t } = useTranslation();

  const steps = [
    {
      image: RefundStep1,
      description: t("processes.refund.step1")
    },
    {
      image: RefundStep2,
      description: t("processes.refund.step2")
    },
    {
      image: RefundStep3,
      description: t("processes.refund.step3")
    },
    {
      image: RefundStep4,
      description: t("processes.refund.step4")
    },
    {
      image: RefundStep5,
      description: t("processes.refund.step5")
    },
    {
      image: RefundStep6,
      description: t("processes.refund.step6")
    }
  ];

  return (
    <div className={styles.destinationArea}>
      <div className={styles.container}>
        <h1 className={styles.wpoSectionTitle}>Refund</h1>
        <div className={styles.stepsContainer}>
          {steps.map((step, index) => (
            <div key={index} className={styles.refundStep}>
              <div className={styles.destinationImg}>
                <img
                  src={step.image}
                  alt={`Refund Step ${index + 1}`}
                  className={styles.screenshot}
                />
              </div>
              <p className={styles.stepDescription}>
                {index + 1}. {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Refund;